import React from 'react';

// ##### ConfirmModal — canonical version. Consolida finance/ModalConfirm.jsx (mais completo,
// tinha `disabled` e `overlayClassName`) e planner/ConfirmModal.jsx (subset compatível).
const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirm action",
  message = "Are you sure you want to proceed?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmButtonClass = "bg-red-600 hover:bg-red-700 text-white shadow",
  cancelButtonClass = "px-4 py-2 rounded-xl border border-gray-300 text-gray-700 hover:bg-gray-100",
  disabled = false,
  /** Tailwind z-index classes when stacking above another modal (e.g. z-[70]). */
  overlayClassName = 'z-50',
}) => {
  if (!isOpen) return null;

  return (
    <div
      className={`fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center ${overlayClassName}`}
    >
      <div className="bg-white p-6 rounded-2xl shadow-xl w-full max-w-md">
        <h3 className="text-lg font-semibold mb-4">{title}</h3>
        <p className="mb-6 text-sm text-gray-700">
          {message}
        </p>
        <div className="flex justify-end gap-4">
          <button
            onClick={onClose}
            disabled={disabled}
            className={cancelButtonClass}
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            disabled={disabled}
            className={`px-4 py-2 rounded-xl ${confirmButtonClass}`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
